import api from '../api';

export const createBonus = async (data) => {
  const response = await api.post('/bonuses', data);
  return response.data;
};

export const getAllBonuses = async () => {
  const response = await api.get('/bonuses');
  return response.data;
};

export const getBonusById = async (id) => {
  const response = await api.get(`/bonuses/${id}`);
  return response.data;
};

export const getBonusesByEmployeeId = async (employeeId) => {
  const response = await api.get(`/bonuses/employee/${employeeId}`);
  return response.data;
};

export const updateBonus = async (id, data) => {
  const response = await api.put(`/bonuses/${id}`, data);
  return response.data;
};

export const deleteBonus = async (id) => {
  const response = await api.delete(`/bonuses/${id}`);
  return response.data;
};
